// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-container[data-v-3988a036]{background:rgba(0,0,0,.25098039215686274);border-radius:7px;border:1px solid #fff;font-family:Source Sans 3;font-size:14px;font-style:normal;font-weight:400;letter-spacing:0;text-align:center;text-transform:uppercase;color:#fff}.progress-bar[data-v-3988a036]{border:4px solid #57585a;border-radius:10px}", ""]);
// Exports
module.exports = exports;
